export const dashboard = {
    selectedMeter: 'Zvolený watt-meter:',
    analyticsLabel: 'Analytiky',
    period: 'Perióda:',
    refreshPeriod: 'Obnovenie:',
    every1secs: 'Každé 1 sekundy',
    every2secs: 'Každé 2 sekundy',
    every5secs: 'Každých 5 sekúnd',
    every10secs: 'Každých 10 sekúnd',
    every30secs: 'Každých 30 sekúnd',
    every60secs: 'Každých 60 sekúnd',
    liveLoading: 'Monitorovanie dát naživo',
    zoomIn: 'Priblížiť',
    zoomOut: 'Oddialiť',
    pvEfficiency: 'Efektivita fotovoltiky',
    pvOwnUsage: 'Spotreba vlastnej energie z fotovoltiky',
    pvProduced: 'Vyprodukované/Použité',
    pvSold: 'Vyprodukované/Predané',
    pvUsed: 'Použité',
    pvBought: 'Nakúpené',
    cloudSubscription: 'Predplatné',
    until: 'Do',
    switchData: 'Spínač',
    noData: 'ŽIADNE ÚDAJE',
    wrongTime: 'Nemáte správne nastavený čas v počítači',
    secondGraph: '2. graf',
    premiumData: 'Prémiové dáta',
    premiumVoltage: 'Napätie (V)',
    premiumApparentPower: 'Zdanlivý výkon',
    premiumCurrent: 'Prúd (A)',
    premiumCosPhi: 'Účinník',
    downloadSvg: 'Nahrať súbor CSV',
    downloadExcel: 'Nahrať súbor Excel',
    onePerSecond: '1 vzorka za sekundu',
    onePerMinute: '1 vzorka za minútu',
    onePer15Minutes: '1 vzorka za 15 minútu',
    onePerHour: '1 vzorka za hodinu',
    resolution: 'Resolution',
    kwhCost: 'Náklady na kilowatt',
    wattUnit: 'Watt',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogram',
    costUnit: '€',
    batteryCharge: 'stav nabitia batérie',
    autonomy: 'autonómia',
    grid: 'Siete',
    production: 'Výroby',
    battery: 'Batérie',
    usage: 'Spotreba',
    otherDevices: 'Iné zariadenia',
    chartModeDevice: 'Zariadenie',
    chartModePhases: 'Predvolená',
    E3DC: 'E3DC',
    EnphaseIqEnvoy: 'Enphase IQ Envoy',
    Fenecon: 'FENECON',
    froniusSolarapiV1: 'Fronius Solar Api V1',
    froniusGen24Modbus: 'Fronius Gen24 Modbus TCP/IP',
    kostalPiko: 'Kostal Piko',
    kostalPlenticore: 'Kostal Plenticore',
    kostalSem: 'Kostal Sem',
    kostalSemInverter: 'Kostal Sem Inverter',
    SIEMENS_SENTRON_PAC_FAMILY: 'Siemens Sentron PAC',
    SENEChome: 'SENEC.Home',
    Shelly1PmPv: 'Shelly 1PM PV',
    HuaweiSun2000dongle: 'Huawai Sun 2000 dongle',
    HuaweiDongleSensor: 'Huawai Sun 2000 dongle & sensor',
    MTecEbGen2TCP: 'M-TEC Energy Butler GEN2',
    MTecEbGen3TCP: 'M-TEC Energy Butler GEN3',
    Phoenix: 'Phoenix',
    RctPower: 'RCT Power',
    SmaDataManager: 'SMA Data Manager',
    SmaEnergyMeter: 'SMA Energy Meter',
    SmaHomeManager: 'SMA Home Manager',
    SmaHybrid: 'SMA Hybrid',
    SmaInverter: 'SMA Inverter',
    Solarwatt: 'Solarwatt',
    SolarEdgeHybrid: 'Solar Edge Hybrid',
    SolarEdgeInverter: 'Solar Edge Inverter',
    Solax: 'Solax',
    SolaxCloudApi: 'Solax Cloud',
    Sonnenbatterie: 'sonnenBatterie',
    Sungrow: 'Sungrow',
    SungrowHybrid: 'Sungrow Hybrid',
    Victron: 'Victron Energy',
    xelectrix: 'xelectrix',
    excelFromP1: 'Začiatok prvej tretiny:',
    excelFromP2: 'Začiatok druhej tretiny:',
    excelToP1: 'Koniec prvého obdobia:',
    excelToP2: 'Koniec druhého obdobia:',
    uploadLoadprofile: 'Nahrať Načítať profil',
    uploading: 'nahrávanie',
    uploadStarted: 'nahrávanie súboru sa úspešne spustilo, trvanie asi 5 minút',
    uploadFailed: 'nahrávanie súboru zlyhalo',
    noDataEnergyFlow: 'Tento watt-meter v súčasnosti neodosiela žiadne údaje.',
    noDataEnergyFlowHelp: 'Potrebujete pomoc? Na základe farby stavovej LED vykonajte nasledujúce kroky:',
    noDataEnergyFlowLedGrey: 'Pripojte watt-meter na napájanie',
    noDataEnergyFlowLedBlue1: 'Skontrolujte vašu Wi-Fi sieť',
    noDataEnergyFlowLedBlue2: 'Ak ste zmenili nastavenie lokálej Wi-Fi siete, musíte ju tiež aktualizovať vo watt-metri',
    noDataEnergyFlowLedGreen: 'Kontaktujte nás emailom na adrese: support@watt-analytics.com',
};
